<template>
  <div>
    <div class="content-person mb-4">
      <h1>Personas expuestas</h1>
      <div class="d-flex mt-5">
        <div class="w-25 mr-5">
          <Input
            label="Propios"
            name="propios"
            :value="formData.propios"
            @input="(event) => (formData.propios = event.target.value)"
            :disabled="true"
          />
        </div>
        <div class="w-25">
          <Input
            label="Contratistas"
            name="contractors"
            :value="formData.contractors"
            @input="(event) => (formData.contractors = event.target.value)"
            :disabled="isBusy"
            :required="true"
          />
          <div class="mt-1">
            <div class="content-alert-info">
              <div>
                <img src="@/assets/images/icons/information-line.svg" />
              </div>
              <b> Digita el número de contratistas presentes </b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-form-calification">
      <div class="header">Caracterización</div>
      <form class="mt-5" @submit.prevent="saveData">
        <div class="row">
          <b-col cols="6" class="mb-5">
            <Select
              label="Peligro"
              name="danger"
              v-model="formData.danger"
              :options="dangers"
              :value="formData.danger"
              :required="true"
              :disabled="isBusy"
              @onSelect="onSelectDanger"
            />
          </b-col>
          <b-col cols="6" class="mb-5" v-if="formData.danger">
            <Select
              label="Riesgo anidado"
              name="danger_risk_id"
              v-model="formData.danger_risk_id"
              :options="risks"
              :value="formData.danger_risk_id"
              :required="true"
              :disabled="isBusy"
            />
          </b-col>
          <b-col cols="12" class="mb-5">
            <Textarea
              label="Fuente generadora de peligro"
              name="source_of_danger"
              :rows="'3'"
              :value="formData.source_of_danger"
              @input="
                (event) => (formData.source_of_danger = event.target.value)
              "
              :disabled="isBusy"
              :required="true"
            />
          </b-col>
        </div>
        <div class="d-flex justify-content-center mb-4">
          <button
            class="button_primary"
            type="submit"
            :disabled="isBusy || isDisabled"
          >
            <b-spinner v-if="isBusy" />
            {{ idMatrizIper ? "Guardar cambios" : "Guardar" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import useInputs from "@/components/general/Inputs";
const { Input, Textarea, Select } = useInputs();
import {
  getDangers,
  getRisksByDanger,
} from "@/services/health-tracker/matrizIper/service";
export default {
  components: {
    Input,
    Textarea,
    Select,
  },
  props: {
    totalPropios: {
      type: Number,
      default: 0,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
    idMatrizIper: {
      type: Number,
      default: null,
    },
    record: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      formData: {
        propios: 0,
        contractors: "",
        source_of_danger: "",
        danger: null,
        danger_risk_id: null,
      },
      dangers: [],
      risks: [],
    };
  },
  watch: {
    totalPropios() {
      const me = this;
      me.formData.propios = me.totalPropios;
    },
    record() {
      const me = this;
      if (me.record) me.loadData();
    }
  },
  computed: {
    isDisabled() {
      const me = this;
      const isDisabled =
        me.formData.danger === null ||
        me.formData.contractors === "" ||
        me.formData.source_of_danger === "" ||
        me.formData.danger_risk_id === null
          ? true
          : false;
      return isDisabled;
    },
  },
  methods: {
    async loadDangers() {
      const me = this;
      try {
        const res = await getDangers();
        me.dangers = res;
      } catch (error) {
        console.log(error);
      }
    },
    async loadRisks(id) {
      const me = this;
      try {
        me.formData.danger_risk_id = null;
        const res = await getRisksByDanger(id);
        me.risks = res;
      } catch (error) {
        console.log(error);
      }
    },
    onSelectDanger(value) {
      const me = this;
      me.formData.danger_risk_id = null;
      me.risks = [];
      me.loadRisks(value?.id);
    },
    saveData() {
      const me = this;
      me.$emit("saveData", {
        contractors: me.formData.contractors,
        source_of_danger: me.formData.source_of_danger,
        danger_risk_id: me.formData.danger_risk_id?.id,
      });
    },
    async loadData() {
      const me = this;
      me.formData.danger = null;
      me.formData.danger_risk_id = null;
      me.risks = [];
      me.formData.contractors = me.record?.contractors ? me.record?.contractors : "";
      me.formData.source_of_danger = me.record?.source_of_danger ? me.record?.source_of_danger : "";
      if (me.record?.danger_risk) {
        me.formData.danger = {
          id: me.record?.danger_risk?.danger?.id,
          name: me.record?.danger_risk?.danger?.name,
        };
        await me.loadRisks(me.record?.danger_risk?.danger?.id);
        me.formData.danger_risk_id = {
          id: me.record?.danger_risk?.id,
          name: me.record?.danger_risk?.name,
        };
      }
    },
  },
  async mounted() {
    const me = this;
    me.formData.propios = me.totalPropios;
    await me.loadDangers();
    if (me.record) me.loadData();
  },
};
</script>

<style lang="css">
.content-person {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
}

.content-person h1 {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  border-bottom: 1px solid #cfd8dc;
}
.content-alert-info {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #004bd1;
}
.content-form-calification {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
  text-align: left !important;
}
.content-form-calification .header {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  background-color: #eceff1 !important;
  padding-left: 10px;
}
</style>
